import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Features from "./pages/Features";
import FeatureForTeams from "./pages/FeatureForTeams";
import Compliance from "./pages/Compliance";
import AllFeatures from "./pages/AllFeatures";
import Solutions from "./pages/Solutions";
import EIDs from "./pages/EIDs";
import EResidency from "./pages/EResidency";
import AboutUs from "./pages/AboutUs";
import Contacts from "./pages/Contacts";
import SolutionsChild from "./pages/SolutionsChild";
import { AnimatePresence, motion } from "framer-motion";
import Developers from "./pages/Developers";
import Pricing from "./pages/Pricing";
import CaseStudies from "./pages/CaseStudies";
import CaseStudiesFinancial from "./pages/CaseStudiesFinancial";
import CaseStudiesTelco from "./pages/CaseStudiesTelco";
import CaseStudiesPublic from "./pages/CaseStudiesPublic";
import CaseStudiesProcurement from "./pages/CaseStudiesProcurement";
import CaseStudiesHR from "./pages/CaseStudiesHR";
import CaseStudiesSales from "./pages/CaseStudiesSales";
import CaseStudiesLegal from "./pages/CaseStudiesLegal";
import CaseStudiesCS from "./pages/CaseStudiesCS";
import CustomerStories from "./pages/CustomerStories";
import CustomerStoriesHoovi from "./components/CustomerStories/CustomerStoriesHoovi";
import CustomerStoriesDanishTechnological from "./components/CustomerStories/CustomerStoriesDanishTechnological";
import CustomerStoriesTelecentras from "./components/CustomerStories/CustomerStoriesTelecentras";
import CustomerStoriesFinancingBank from "./components/CustomerStories/CustomerStoriesFinancingBank";
import CustomerStoriesBite from "./components/CustomerStories/CustomerStoriesBite";
import CustomerStoriesLoto from "./components/CustomerStories/CustomerStoriesLoto";
import CustomerStoriesScandagra from "./components/CustomerStories/CustomerStoriesScandagra";
import CustomerStoriesInvega from "./components/CustomerStories/CustomerStoriesInvega";
import CustomerStoriesVaiku from "./components/CustomerStories/CustomerStoriesVaiku";
import Resource from "./pages/Document";
import $ from "jquery";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import PdfViewer from "./components/PDF_Viewer/PdfViewer";
import PdfViewer2 from "./components/PDF_Viewer/PdfViewer2";
import PdfViewer3 from "./components/PDF_Viewer/PdfViewer3";
import PdfViewer4 from "./components/PDF_Viewer/PdfViewer4";
import PdfViewer5 from "./components/PDF_Viewer/PdfViewer5";
import DeepLink from "./pages/DeepLink";
import Download from "./pages/Download";
import NotFound from "./pages/NotFound";
import { getConsent, hasConsent, setConsent } from "./utils/CookieConsent";
// import { clearAnalyticsCookies } from "./utils/clearAnalytics";
// import AnalyticsLoader from "./pages/AnalyticsLoader";

import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import TermsOfService from "./pages/TermsOfService";
import CookiePreferencesButton from "./pages/CookieSetting";
import SignatureValidationServicePracticeStatementAndPolicy from "./pages/SignatureValidationServicePracticeStatementAndPolicy";
import PdfViewer6 from "./components/PDF_Viewer/PdfViewer6";
import PdfViewer7 from "./components/PDF_Viewer/PdfViewer7";
import ExternalRedirect from "./components/ExternalRedirect";
import ScrollToTop from "./utils/ScrollToTop";
import PricingDeployment from "./pages/PricingDeployment";
window.jQuery = $;
window.$ = $;

const CookieModal = ({ children }) => createPortal(children, document.body);

// Component NGOÀI: chỉ tính basename (dựa vào window.location, không cần Router)
// rồi render BrowserRouter. useLocation() KHÔNG được gọi ở đây.
function RoutesWithAnimation() {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  // Path đã có prefix ngôn ngữ hợp lệ chưa (/en, /vi, /en/..., /vi/...)
  const hasLocalePrefix =
    pathname === "/en" ||
    pathname === "/vi" ||
    pathname.startsWith("/en/") ||
    pathname.startsWith("/vi/");

  // Redirect bất kỳ path nào KHÔNG có prefix -> "/en" + path (giữ query & hash)
  // phải nằm trong useEffect (side-effect), không được gọi trực tiếp trong thân hàm render.
  useEffect(() => {
    if (!hasLocalePrefix) {
      const newPath = pathname === "/" ? "/en" : `/en${pathname}`;
      window.location.replace(`${newPath}${search}${hash}`);
    }
  }, [pathname, search, hash, hasLocalePrefix]);

  if (!hasLocalePrefix) {
    // Đang chờ redirect ở useEffect, không render gì cả
    return null;
  }

  const basename = pathname.startsWith("/vi") ? "/vi" : "/en";
  return (
    <BrowserRouter basename={basename}>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

// Component TRONG: nằm bên trong BrowserRouter nên useLocation() dùng được hợp lệ.
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <ScrollToTop />
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/features-for-teams" element={<FeatureForTeams />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route
          path="/partner/quantera"
          element={<ExternalRedirect to="https://gopaperless.quantera.vn" />}
        />
        <Route path="/documentation" element={<Resource />} />
        {/* ------------------------------------------------------------------------------------ */}
        {/* START: Những link mà ẩn khỏi user */}
        {/* <Route
          path="/compliance/terms-of-service"
          element={<TermsOfService />}
        /> */}
        {/* 
        <Route path="/compliance/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/compliance/acceptable-use-policy"
          element={<AcceptableUsePolicy />}
        />
        <Route path="/compliance/dpa" element={<DPA />} />
        <Route path="/compliance/cookie-policy" element={<CookiePolicy />} />
        <Route
          path="/compliance/partnership-agreement"
          element={<PartnershipAgreement />}
        />
        <Route
          path="/compliance/list-of-subprocessors"
          element={<SubProcessors />}
        />
        <Route
          path="/compliance/vulnerability-disclosure-policy"
          element={<VulnerabilityDisclosurePolicy />}
        />
        <Route
          path="/compliance/dispute-resolution"
          element={<DisputeResolution />}
        />
     
        <Route
          path="/compliance/partnership-general-terms"
          element={<PartnershipGeneralTerms />}
        />
        <Route
          path="/compliance/partnership-special-terms-referral"
          element={<PartnershipSpecialTermsReferral />}
        />
        <Route
          path="/compliance/partnership-special-terms-reseller"
          element={<PartnershipSpecialTermsReseller />}
        />
        <Route
          path="/compliance/partnership-special-terms-solution"
          element={<PartnershipSpecialTermsSolution />}
        /> */}
        {/* END: Những link mà ẩn khỏi user */}
        {/* ------------------------------------------------------------------------------------ */}
        {/* <Route
          path="/compliance/signature-validation-service-practice-statement-and-policy"
          element={<SignatureValidationServicePracticeStatementAndPolicy />}
        /> */}
        <Route path="/all-features" element={<AllFeatures />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route
          path="/solutions/signature-collection"
          element={<SolutionsChild id="signature-collection" />}
        />
        <Route
          path="/solutions/e-signing-api"
          element={<SolutionsChild id="e-signing-api" />}
        />
        <Route
          path="/solutions/e-identification-api"
          element={<SolutionsChild id="e-identification-api" />}
        />
        <Route
          path="/solutions/e-sealing-api"
          element={<SolutionsChild id="e-sealing-api" />}
        />
        <Route
          path="/solutions/agent"
          element={<SolutionsChild id="agent-api" />}
        />
        <Route path="/eids" element={<EIDs />} />
        <Route path="/e-residency" element={<EResidency />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/developers" element={<Developers />} />
        {/* <Route path="/pricing/portal" element={<Pricing id="portal" />} />
        <Route path="/pricing/api" element={<Pricing id="api" />} /> */}
        <Route path="/deployment" element={<PricingDeployment />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route
          path="/case-studies/financial"
          element={<CaseStudiesFinancial />}
        />
        <Route path="/case-studies/telco" element={<CaseStudiesTelco />} />
        <Route path="/case-studies/public" element={<CaseStudiesPublic />} />
        <Route
          path="/case-studies/procurement"
          element={<CaseStudiesProcurement />}
        />
        <Route path="/case-studies/hr" element={<CaseStudiesHR />} />
        <Route path="/case-studies/sales" element={<CaseStudiesSales />} />
        <Route path="/case-studies/legal" element={<CaseStudiesLegal />} />
        <Route path="/case-studies/cs" element={<CaseStudiesCS />} />
        <Route path="/customer-stories" element={<CustomerStories />} />
        <Route
          path="/customer-stories/hoovi"
          element={<CustomerStoriesHoovi />}
        />
        <Route
          path="/customer-stories/telecenter"
          element={<CustomerStoriesTelecentras />}
        />
        <Route
          path="/customer-stories/danish-technological-institute"
          element={<CustomerStoriesDanishTechnological />}
        />
        <Route
          path="/customer-stories/bite-it"
          element={<CustomerStoriesBite />}
        />
        <Route
          path="/customer-stories/general-financing-bank"
          element={<CustomerStoriesFinancingBank />}
        />
        <Route
          path="/customer-stories/loto-it"
          element={<CustomerStoriesLoto />}
        />
        <Route
          path="/customer-stories/scandagra"
          element={<CustomerStoriesScandagra />}
        />
        <Route
          path="/customer-stories/invega"
          element={<CustomerStoriesInvega />}
        />
        <Route
          path="/customer-stories/vaiku-linija"
          element={<CustomerStoriesVaiku />}
        />
        <Route
          path="/uploads/GoPaperless-ChinhSachBaoMatThongTin"
          element={<PdfViewer />}
        />
        <Route
          path="/uploads/GoPaperless-InformationSecurityPolicy"
          element={<PdfViewer />}
        />
        <Route
          path="/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
          element={<PdfViewer2 />}
        />
          <Route
          path="/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"
          element={<PdfViewer2 />}
        />
        <Route
          path="/uploads/GoPaperless-CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeID"
          element={<PdfViewer3 />}
        />
          <Route
          path="/uploads/GoPaperless-WarningDataSharingFromVNeID"
          element={<PdfViewer3 />}
        />
        <Route
          path="/uploads/Certificate-ISO-2700-2022-Mobile-ID-20241209"
          element={<PdfViewer4 />}
        />
        <Route path="/uploads/13nd-signed" element={<PdfViewer5 />} />
        <Route
          path="/uploads/GoPaperless-DieuKhoanVaDieuKienSuDung"
          element={<PdfViewer6 />}
        />
          <Route
          path="/uploads/GoPaperless-TermService"
          element={<PdfViewer6 />}
        />
        <Route path="/uploads/356nd-signed" element={<PdfViewer7 />} />
        <Route
          path="/open-gopaperless-agent-in-desktop"
          element={<DeepLink />}
        />
                {/* <Route path="/uploads/GoPaperless-TermServiceEN" element={<PdfViewer8 />} />

        <Route path="/uploads/GoPaperless-TermServiceVI" element={<PdfViewer9 />} /> */}
        <Route path="/downloads" element={<Download />} />
        {/* <Route path="/digital-signature" element={<Landing />} /> */}
        {/* <Route path="/youtube-demo" element={<YouTubePage />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}
const ToggleSwitch = ({ checked, onChange }) => (
  <div
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log("after prevent:", e.defaultPrevented);
      onChange(!checked);
    }}
    style={{
      position: "relative",
      width: "50px",
      height: "26px",
      flexShrink: 0,
      marginTop: "4px",
      cursor: "pointer",
    }}
  >
    <span
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: checked ? "#fbc710" : "#ccc",
        transition: "0.3s",
        borderRadius: "34px",
      }}
    />
    <span
      style={{
        position: "absolute",
        height: "20px",
        width: "20px",
        left: "3px",
        bottom: "3px",
        backgroundColor: "white",
        transition: "0.3s",
        borderRadius: "50%",
        transform: checked ? "translateX(24px)" : "translateX(0)",
      }}
    />
  </div>
);

const App = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [functional, setFunctional] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [showModal]);

  useEffect(() => {
    console.log("App MOUNTED");
    return () => {
      console.log("App UNMOUNTED");
    };
  }, []);

  // Hiển thị banner nếu CHƯA có consent
  useEffect(() => {
    const saved = getConsent();
    if (!saved) {
      setShowBanner(true);
    }
  }, []);

  // Sync trạng thái toggle khi mở modal
  useEffect(() => {
    if (!showModal) return;
    const saved = getConsent();
    if (saved) {
      setFunctional(!!saved.functional);
      setAnalytics(!!saved.analytics);
      setMarketing(!!saved.marketing);
    }
  }, [showModal]);

  const acceptAll = () => {
    const allPrefs = {
      functional: true,
      analytics: true,
      marketing: true,
    };
    setConsent(allPrefs);
    // Set cookie for non-www domain
    document.cookie = `cookie_preferences_gopaperless=${encodeURIComponent(
      JSON.stringify(allPrefs),
    )}; path=/; domain=.gopaperless.mobile-id.vn; max-age=31536000; SameSite=Lax`;

    setShowBanner(false);
  };

  const rejectAll = () => {
    const rejectPrefs = {
      functional: false,
      analytics: false,
      marketing: false,
    };
    setConsent(rejectPrefs);

    // Set cookie for non-www domain
    document.cookie = `cookie_preferences_gopaperless=${encodeURIComponent(
      JSON.stringify(rejectPrefs),
    )}; path=/; domain=.gopaperless.mobile-id.vn; max-age=31536000; SameSite=Lax`;

    setShowBanner(false);
  };

  const savePreferences = () => {
    const prefs = {
      functional,
      analytics,
      marketing,
    };
    setConsent(prefs);

    // Set cookie for non-www domain
    document.cookie = `cookie_preferences_gopaperless=${encodeURIComponent(
      JSON.stringify(prefs),
    )}; path=/; domain=.gopaperless.mobile-id.vn; max-age=31536000; SameSite=Lax`;

    // if (!functional) {
    //   localStorage.removeItem("i18nextLng");
    // }

    setShowModal(false);
    setShowBanner(false);
  };

    useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handler = (e) => {
      if (!e.detail?.analytics) {
        // clearAnalyticsCookies();
        window.__analyticsLoaded = false;
      }
    };

    window.addEventListener("cookie-consent-changed", handler);
    return () => window.removeEventListener("cookie-consent-changed", handler);
  }, []);

  // function LocationProvider({ children }) {
  //   return <AnimatePresence>{children}</AnimatePresence>;
  // }

  // function RoutesWithAnimation() {
  //   const location = useLocation();

  //   return (
  //        <AnimatePresence mode="wait">
  //       <Routes location={location} key={location.pathname}>
  //       <Route path="/" element={<Home />} />
  //       <Route path="/features" element={<Features />} />
  //       <Route path="/features-for-teams" element={<FeatureForTeams />} />
  //       <Route path="/compliance" element={<Compliance />} />
  //       <Route path="/documentation" element={<Resource />} />
  //       {/* ------------------------------------------------------------------------------------ */}
  //       {/* START: Những link mà ẩn khỏi user */}
  //       {/* <Route
  //         path="/compliance/terms-of-service"
  //         element={<TermsOfService />}
  //       />
  //       <Route path="/compliance/privacy-policy" element={<PrivacyPolicy />} />
  //       <Route
  //         path="/compliance/acceptable-use-policy"
  //         element={<AcceptableUsePolicy />}
  //       />
  //       <Route path="/compliance/dpa" element={<DPA />} />
  //       <Route path="/compliance/cookie-policy" element={<CookiePolicy />} />
  //       <Route
  //         path="/compliance/partnership-agreement"
  //         element={<PartnershipAgreement />}
  //       />
  //       <Route
  //         path="/compliance/list-of-subprocessors"
  //         element={<SubProcessors />}
  //       />
  //       <Route
  //         path="/compliance/vulnerability-disclosure-policy"
  //         element={<VulnerabilityDisclosurePolicy />}
  //       />
  //       <Route
  //         path="/compliance/dispute-resolution"
  //         element={<DisputeResolution />}
  //       />
  //       <Route
  //         path="/compliance/signature-validation-service-practice-statement-and-policy"
  //         element={<SignatureValidationServicePracticeStatementAndPolicy />}
  //       />
  //       <Route
  //         path="/compliance/partnership-general-terms"
  //         element={<PartnershipGeneralTerms />}
  //       />
  //       <Route
  //         path="/compliance/partnership-special-terms-referral"
  //         element={<PartnershipSpecialTermsReferral />}
  //       />
  //       <Route
  //         path="/compliance/partnership-special-terms-reseller"
  //         element={<PartnershipSpecialTermsReseller />}
  //       />
  //       <Route
  //         path="/compliance/partnership-special-terms-solution"
  //         element={<PartnershipSpecialTermsSolution />}
  //       /> */}
  //       {/* END: Những link mà ẩn khỏi user */}
  //       {/* ------------------------------------------------------------------------------------ */}
  //       <Route path="/all-features" element={<AllFeatures />} />
  //       <Route path="/solutions" element={<Solutions />} />
  //       <Route
  //         path="/solutions/signature-collection"
  //         element={<SolutionsChild id="signature-collection" />}
  //       />
  //       <Route
  //         path="/solutions/e-signing-api"
  //         element={<SolutionsChild id="e-signing-api" />}
  //       />
  //       <Route
  //         path="/solutions/e-identification-api"
  //         element={<SolutionsChild id="e-identification-api" />}
  //       />
  //       <Route
  //         path="/solutions/e-sealing-api"
  //         element={<SolutionsChild id="e-sealing-api" />}
  //       />
  //       <Route
  //         path="/solutions/agent"
  //         element={<SolutionsChild id="agent-api" />}
  //       />
  //       <Route path="/eids" element={<EIDs />} />
  //       <Route path="/e-residency" element={<EResidency />} />
  //       <Route path="/about-us" element={<AboutUs />} />
  //       <Route path="/contacts" element={<Contacts />} />
  //       <Route path="/developers" element={<Developers />} />
  //       <Route path="/pricing/portal" element={<Pricing id="portal" />} />
  //       <Route path="/pricing/api" element={<Pricing id="api" />} />
  //       <Route path="/case-studies" element={<CaseStudies />} />
  //       <Route
  //         path="/case-studies/financial"
  //         element={<CaseStudiesFinancial />}
  //       />
  //       <Route path="/case-studies/telco" element={<CaseStudiesTelco />} />
  //       <Route path="/case-studies/public" element={<CaseStudiesPublic />} />
  //       <Route
  //         path="/case-studies/procurement"
  //         element={<CaseStudiesProcurement />}
  //       />
  //       <Route path="/case-studies/hr" element={<CaseStudiesHR />} />
  //       <Route path="/case-studies/sales" element={<CaseStudiesSales />} />
  //       <Route path="/case-studies/legal" element={<CaseStudiesLegal />} />
  //       <Route path="/case-studies/cs" element={<CaseStudiesCS />} />
  //       <Route path="/customer-stories" element={<CustomerStories />} />
  //       <Route
  //         path="/customer-stories/hoovi"
  //         element={<CustomerStoriesHoovi />}
  //       />
  //       <Route
  //         path="/customer-stories/telecenter"
  //         element={<CustomerStoriesTelecentras />}
  //       />
  //       <Route
  //         path="/customer-stories/danish-technological-institute"
  //         element={<CustomerStoriesDanishTechnological />}
  //       />
  //       <Route
  //         path="/customer-stories/bite-it"
  //         element={<CustomerStoriesBite />}
  //       />
  //       <Route
  //         path="/customer-stories/general-financing-bank"
  //         element={<CustomerStoriesFinancingBank />}
  //       />
  //       <Route
  //         path="/customer-stories/loto-it"
  //         element={<CustomerStoriesLoto />}
  //       />
  //       <Route
  //         path="/customer-stories/scandagra"
  //         element={<CustomerStoriesScandagra />}
  //       />
  //       <Route
  //         path="/customer-stories/invega"
  //         element={<CustomerStoriesInvega />}
  //       />
  //       <Route
  //         path="/customer-stories/vaiku-linija"
  //         element={<CustomerStoriesVaiku />}
  //       />
  //       <Route
  //         path="/uploads/GoPaperless-ChinhSachBaoMatThongTin"
  //         element={<PdfViewer />}
  //       />
  //       <Route
  //         path="/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan"
  //         element={<PdfViewer2 />}
  //       />
  //       <Route
  //         path="/uploads/GoPaperless-CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeID"
  //         element={<PdfViewer3 />}
  //       />
  //       <Route
  //         path="/uploads/Certificate-ISO-2700-2022-Mobile-ID-20241209"
  //         element={<PdfViewer4 />}
  //       />
  //       <Route path="/uploads/13nd-signed" element={<PdfViewer5 />} />
  //       <Route
  //         path="/open-gopaperless-agent-in-desktop"
  //         element={<DeepLink />}
  //       />
  //       <Route path="/downloads" element={<Download />} />
  //       <Route path="/youtube-demo" element={<YouTubePage />} />
  //       <Route path="*" element={<NotFound />} />
  //     </Routes>
  //     </AnimatePresence>
  //   );
  // }

  // eslint-disable-next-line no-unused-vars
  const [nonce, setNonce] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    async function fetchNonce() {
      try {
        const response = await fetch("/auth/nonce");
        const fetchedNonce = response.headers.get("X-Nonce");

        if (fetchedNonce) {
          setNonce(fetchedNonce);
          window.nonce = fetchedNonce;
          document
            .getElementById("nonce-meta")
            ?.setAttribute("data-nonce", fetchedNonce);

          // Cập nhật nonce cho các script/style đã có
          document.querySelectorAll("script, style").forEach((tag) => {
            if (!tag.hasAttribute("nonce")) {
              tag.setAttribute("nonce", fetchedNonce);
            }
          });
        }
      } catch (error) {
        console.error("Lỗi lấy nonce:", error);
      }
    }

    fetchNonce();
  }, []);

  const bannerRef = useRef(null);
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (showBanner && bannerRef.current) {
        const height = bannerRef.current.offsetHeight;
        setBannerHeight(height);
        document.documentElement.style.setProperty(
          "--cookie-banner-height",
          `${height}px`,
        );
      } else {
        setBannerHeight(0);
        document.documentElement.style.setProperty(
          "--cookie-banner-height",
          "0px",
        );
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      document.documentElement.style.setProperty(
        "--cookie-banner-height",
        "0px",
      );
    };
  }, [showBanner]);
  useLayoutEffect(() => {
    if (!showBanner || !bannerRef.current) {
      setBannerHeight(0);
      return;
    }

    const height = bannerRef.current.offsetHeight;
    setBannerHeight(height);

    // Resize observer để bắt mọi thay đổi kích thước (do text wrap, ngôn ngữ, font load, v.v.)
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setBannerHeight(entry.target.offsetHeight);
      }
    });

    resizeObserver.observe(bannerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [showBanner]); // Chỉ depend vào showBanner

  // Bonus: vẫn giữ resize window để an toàn tuyệt đối
  useEffect(() => {
    const handleResize = () => {
      if (bannerRef.current) {
        setBannerHeight(bannerRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showBanner]);
  return (
    <>
      {/* && <AnalyticsLoader /> */}
      {hasConsent("analytics")}
      <CookiePreferencesButton onClick={() => setShowModal(true)} />
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          title={t("navbar.back_to_top")}
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "#266fee",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            zIndex: 9999,
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 22,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
      <div
        style={{
          marginBottom: showBanner ? `${bannerHeight}px` : "0px",
          transition: "margin-bottom 0.3s ease",
        }}
      >
        <RoutesWithAnimation />
      </div>

      {showBanner && (
        <>
          <div
            ref={bannerRef}
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              background: "#0033ad",
              color: "#fff",
              padding: "1%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "20px",
              boxShadow: "0 -4px 10px rgba(0,0,0,0.2)",
              fontSize: "15px",
              lineHeight: "1.6",
              zIndex: 9999,
            }}
          >
            {/* Text bên trái */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                flex: "1",
                minWidth: "auto",
                textAlign: "left",
                flexWrap: "wrap",
              }}
            >
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                {t("cookie_consent.note")}
              </span>
              <span style={{ fontSize: "15px" }}>
                {t("cookie_consent.note_des")}
              </span>
            </div>

            {/* 3 nút bên phải */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {/* Cookie Preferences */}
              <button
                onClick={() => setShowModal(true)}
                style={{
                  background: "transparent",
                  color: "#FFD700",
                  border: "1px solid #FFD700",
                  fontSize: "15px",
                  fontWeight: 500,
                  padding: "10px",
                  borderRadius: "6px",
                  minWidth: "180px",
                  cursor: "pointer",
                }}
              >
                {t("cookie_consent.button_custom")}
              </button>

              {/* Reject All */}
              <button
                onClick={rejectAll}
                style={{
                  background: "transparent",
                  color: "#FFD700",
                  border: "1px solid #FFD700",
                  fontSize: "15px",
                  fontWeight: 500,
                  padding: "10px",
                  borderRadius: "6px",
                  minWidth: "180px",
                  cursor: "pointer",
                }}
              >
                {t("cookie_consent.button_reject")}
              </button>

              {/* Accept All Cookies */}
              <button
                onClick={acceptAll}
                style={{
                  background: "#fbc70f",
                  color: "#0033ad",
                  fontSize: "15px",
                  fontWeight: 500,
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #FFD700",
                  minWidth: "180px",
                  cursor: "pointer",
                }}
              >
                {t("cookie_consent.button_accept")}
              </button>
            </div>
          </div>
        </>
      )}
      {/* Modal Preferences */}
      {showModal && (
        <CookieModal>
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000,
              padding: "20px",
            }}
          >
            <div
              style={{
                background: "#0033ad",
                color: "#fff",
                borderRadius: "10px",
                width: "100%",
                maxWidth: isMobile ? "90dvw" : "60dvw",
                maxHeight: "90vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div
                style={{
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 24px",
                  borderBottom: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <h2
                  style={{
                    color: "white",
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: 700,
                  }}
                >
                  {t("cookie_consent.title")}
                </h2>
                <span
                  onClick={() => setShowModal(false)}
                  style={{
                    fontSize: "28px",
                    cursor: "pointer",
                    lineHeight: "1",
                    padding: "4px 8px",
                  }}
                >
                  ×
                </span>
              </div>
              {/* Body */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflowY: "auto",
                  padding: "16px 24px",
                  gap: "30px",
                }}
              >
                {/* Strictly Necessary */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "40px",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {" "}
                      {t("cookie_consent.content1")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content1")}
                    </small>
                  </div>
                  <div
                    style={{
                      flexShrink: 0,
                      justifyContent: "center",
                      marginTop: "4px",
                    }}
                  >
                    <strong style={{ color: "#fbc710" }}>
                      {t("cookie_consent.always")}
                    </strong>
                  </div>
                </div>

                {/* Functional */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content2")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content2")}
                    </small>
                  </div>
                  <ToggleSwitch checked={functional} onChange={setFunctional} />
                </div>

                {/* Analytics */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content3")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content3")}
                    </small>
                  </div>
                  <ToggleSwitch checked={analytics} onChange={setAnalytics} />
                </div>

                {/* Marketing */}
                <div
                  style={{ display: "flex", gap: "40px", alignItems: "center" }}
                >
                  <div style={{ flex: 1 }}>
                    <strong style={{ fontSize: "16px" }}>
                      {t("cookie_consent.content4")}
                    </strong>
                    <br />
                    <small
                      style={{
                        opacity: 0.9,
                        lineHeight: "1.5",
                        fontSize: "15px",
                      }}
                    >
                      {t("cookie_consent.des_content4")}
                    </small>
                  </div>
                  <ToggleSwitch checked={marketing} onChange={setMarketing} />
                </div>
              </div>
              {/* Buttons */}
              <div
                style={{
                  flexShrink: 0,
                  display: "flex",
                  flexDirection: "row",
                  gap: "12px",
                  justifyContent: "flex-end",
                  borderTop: "1px solid rgba(255,255,255,0.2)",
                  flexWrap: "wrap",
                  padding: "16px 24px",
                }}
              >
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    background: "transparent",
                    color: "#FFD700",
                    border: "1px solid #FFD700",
                    fontWeight: 500,
                    padding: "10px",
                    borderRadius: "6px",
                    minWidth: "120px",
                    fontSize: "15px",
                  }}
                >
                  {t("cookie_consent.button_cancel")}
                </button>
                <button
                  type="button"
                  onClick={savePreferences}
                  style={{
                    background: "#fbc70f",
                    color: "#0033ad",
                    padding: "10px",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: 500,
                    minWidth: "160px",
                    fontSize: "15px",
                  }}
                >
                  {t("cookie_consent.button_save")}
                </button>
              </div>
            </div>
          </div>
        </CookieModal>
      )}
    </>
  );
};

export default App;